import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Loading from '../../features/shared/components/Loading'
import PageErrorBoundary from './PageErrorBoundary'

/**
 * The page card for every page but the tables, inside AppShellLayout, on its
 * canvas color (so the gaps around the page's side panels match it).
 */
export default function PrivateLayout() {
  return (
    <div className="app-page-card flex min-w-0 flex-1 overflow-hidden bg-lighter">
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <main className="flex-1 overflow-auto">
          <PageErrorBoundary>
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </PageErrorBoundary>
        </main>
      </div>
    </div>
  )
}
